import React, { useEffect, useRef, useState } from 'react'
import { Grid, Hidden, TextField, Typography } from "@mui/material";
import { Button } from "../../Material";
import { Img } from "../../Image";
import { Link } from '../../Link';
import { useIsMobile } from "../../../hooks/useIsMobile";
import { navigate } from "gatsby";
import { useStyles } from "./Subcription.styles";


export function SubscriptionForm() {
	const { classes, cx } = useStyles()
	const isMobile = useIsMobile('md')

	const [email, setEmail] = useState('')
	const [error, setError] = useState(false)
	const [success, setSuccess] = useState(false)

	const URL = process.env.GATSBY_HUBSPOT_EMAIL_SUBMIT_URL
	const portalId = process.env.GATSBY_HUBSPOT_EMAIL_PORTAL_ID
	const formId = process.env.GATSBY_HUBSPOT_EMAIL_FORM_ID

	async function onSubmit() {
		if (email.length === 0) {
			return;
		}
		const payload = {
			fields: [{
				objectTypeId: "0-1",
				name: "email",
				value: email,
			}],
			context: {
				pageName: "Kredi blog"
			}
		}

		await fetch(`${URL}${portalId}/${formId}`, {
			method: "POST",
			body: JSON.stringify(payload),
			headers: {
				"content-type": "application/json"
			}
		})

		setSuccess(true)
		navigate("#success-message")
	}

	return (
		<section className={classes.root}>
			<Grid container className={classes.container}>
				<div className={classes.emailImageContainer}>
					<Img src="/assets/images/blog/blog_sb_open_mail.svg" className='desktop' />
					<Img src="/assets/images/blog/blog_sb_open_mail_mobile.svg" className='mobile' />
				</div>
				<span id="success-message" style={{ position: 'absolute' }}>&nbsp;</span>
				<br />
				<Grid item xs={12}>
					<Grid container className={classes.subContainer}>
						{success ? (
							<>
								<Grid item xs={12}>
									<Typography className={classes.title}> ¡Gracias por suscribirte! </Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography className={classes.description}>
										Síguenos también en nuestras redes
									</Typography>
								</Grid>
								<Grid
									item
									xs={12}
									className={classes.socialIconsContainer}
								>
									{/* @ts-ignore */}
									<Hidden mdDown>
										<Link className='desktop' target={'_blank'} to='https://www.facebook.com/kredi.mx'>
											<Img src="/assets/images/blog/blog_sb_icon_fb.svg" />
										</Link>
										<Link className='desktop' target={'_blank'} to='https://www.linkedin.com/company/kredimx'>
											<Img src="/assets/images/blog/blog_sb_icon_linkedin.svg" />
										</Link>
										<Link className='desktop' target={'_blank'} to='https://twitter.com/kredimx'>
											<Img src="/assets/images/blog/blog_sb_icon_twitter.svg" />
										</Link>
										<Link className='desktop' target={'_blank'} to='https://www.instagram.com/kredi.mx'>
											<Img src="/assets/images/blog/blog_sb_icon_insta.svg" />
										</Link>
									</Hidden>

									{/* @ts-ignore */}
									<Hidden lgUp>
										<Link className='mobile' target={'_blank'} to='https://www.facebook.com/kredi.mx'>
											<Img src="/assets/images/blog/blog_sb_icon_fb_mobile.svg" />
										</Link>
										<Link className='mobile' target={'_blank'} to='https://www.linkedin.com/company/kredimx'>
											<Img src="/assets/images/blog/blog_sb_icon_linkedin_mobile.svg" />
										</Link>
										<Link className='mobile' target={'_blank'} to='https://twitter.com/kredimx'>
											<Img src="/assets/images/blog/blog_sb_icon_twitter_mobile.svg" />
										</Link>
										<Link className='mobile' target={'_blank'} to='https://www.instagram.com/kredi.mx'>
											<Img src="/assets/images/blog/blog_sb_icon_insta_mobile.svg" />
										</Link>
									</Hidden>
								</Grid>
							</>
						) : (
							<>
								<Grid item xs={12}>
									<Typography className={classes.title}> ¡Recibe la información más reciente que compartimos! </Typography>
								</Grid>
								<Grid item xs={12}>
									<TextField
										id="email"
										name="email"
										value={email}
										onChange={(event) => setEmail(event.currentTarget.value)}
										placeholder='Ingresa tu correo'
										variant="outlined"
										color="primary"
										className={classes.emailInput}
									/>
								</Grid>
								<Grid item xs={12}>
									<Button
										variant="contained"
										color="primary"
										className={classes.suscribeButton}
										onClick={onSubmit}
									>
										Suscríbete
									</Button>
								</Grid>
							</>
						)}
					</Grid>
				</Grid>
			</Grid>
		</section>
	)
}